/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InputModule} from '../../../shared/input/input.module';
import {PartNumberChangesAdditionalInputModule} from '../../shared/part-number-changes-additional-input/part-number-changes-additional-input.module';
import {PncLotNumberInputComponent} from './pnc-lot-number-input.component';
import {PncAdditionalLotNumberComponent} from './pnc-additional-lot-number/pnc-additional-lot-number.component';
import {PncSeveralFullLotNumberModalModule} from './pnc-several-full-lot-number-modal/pnc-several-full-lot-number-modal.module';

@NgModule({
    declarations: [
        PncLotNumberInputComponent,
        PncAdditionalLotNumberComponent
    ],
    imports: [
        CommonModule,
        InputModule,
        PartNumberChangesAdditionalInputModule,
        PncSeveralFullLotNumberModalModule
    ],
    exports: [
        PncLotNumberInputComponent
    ]
})
export class PncLotNumberInputModule {
}
